import React from "react";
import { CheckCircle2, MessageCircle, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ResumenDelCurso() {
  return <section id="resumen-del-curso" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
        backgroundSize: "40px 40px"
      }} />
        <div className="absolute inset-0 bg-gradient-to-b from-background/10 via-background/80 to-background" />
      </div>

      {}
      <div className="absolute top-1/4 left-0 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[120px] pointer-events-none z-0" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-start">
            <Badge variant="outline" className="mb-6 border-primary/30 text-primary bg-primary/10 px-3 py-1">
              Programa de Formación Profesional
            </Badge>
            
            <div className="relative">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-sans font-extrabold uppercase tracking-tight text-foreground leading-[1.1]">
                Supervisor <br />
                <span className="relative inline-block text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/60 drop-shadow-[0_0_15px_rgba(var(--color-primary),0.5)]">
                  Forestal
                </span>
              </h1>
            </div>

            <p className="mt-6 text-lg sm:text-xl font-sans font-medium text-muted-foreground max-w-2xl leading-relaxed">
              El rol de Supervisor Forestal es fundamental para el desarrollo sostenible y la eficiencia de la industria maderera en Uruguay. Lidera equipos en el terreno, asegura el estricto cumplimiento de normativas ambientales y optimiza las operaciones de cosecha y logística en uno de los sectores con mayor proyección y crecimiento del país.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-4 w-full sm:w-auto">
              <Link to="https://wa.me/59896344395" newTab>
                <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-bold bg-[#25D366] hover:bg-[#22c35e] text-white border-none shadow-md">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Consultar por WhatsApp
                </Button>
              </Link>
              <Link to="https://mpago.la/1WfMEZk" newTab>
                <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-bold bg-[#009EE3] hover:bg-[#008ED2] text-white border-none shadow-md group">
                  Pagar con Mercado Pago
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground px-4 py-2">
                <CheckCircle2 className="size-5 text-primary" />
                <span>Certificación Oficial</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative mt-10 lg:mt-0">
            {}
            <div className="absolute -top-5 -right-5 z-30">
              <Badge variant="secondary" className="px-4 py-2 text-sm font-bold shadow-xl border border-secondary/20">
                Alta Demanda
              </Badge>
            </div>

            {}
            <div className="relative rounded-[24px] p-2 bg-white/5 backdrop-blur-md border border-white/10 shadow-2xl">
              <div className="relative rounded-[20px] overflow-hidden aspect-[4/5] bg-muted">
                {}
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/forest_operation_action.png" alt="Supervisor Forestal en acción coordinando operaciones en el terreno" className="object-cover w-full h-full scale-105 hover:scale-100 transition-transform duration-700 ease-out" />
                
                {}
                <div className="absolute inset-0 bg-primary/20 mix-blend-overlay pointer-events-none" />
                
                {}
                <div className="absolute inset-0 shadow-[inset_0_0_40px_rgba(0,0,0,0.6)] pointer-events-none rounded-[20px]" />
              </div>
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-secondary/20 rounded-full blur-[40px] pointer-events-none z-0" />
          </div>

        </div>
      </div>
    </section>;
}